





import { Component, Vue } from 'vue-property-decorator';
import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import { ThemeConfModule } from '@/store/modules/theme';
import { Fragment } from 'vue-fragment';
import { ThemeConf, TemplatedSlide, DisplayLink } from '@/types/ThemeConf';
import { localize } from '@/filters/localize';
var sanitizeUrlHelper = require('@braintree/sanitize-url').sanitizeUrl;
const Theme = getModule(ThemeConfModule, store);


@Component({
  components: {
    Fragment
  }
})
export default class ThemedSlide extends Vue {
  slideContent: TemplatedSlide | undefined;
  themeConfig: ThemeConf | null = null;

  created() {
    this.themeConfig = Theme.getTheme;
    this.slideContent = this.themeConfig?.slides?.insertSlide;
  }

  get title() :string{
    return this.slideContent?.title ?? localize('Learning material');
  }

  get content() :string{
    return this.slideContent?.content ?? '';
  }

  get links() :Array<DisplayLink>{
    return this.slideContent?.links ?? [];
  }

  sanitizeUrl(url: string) {
    return sanitizeUrlHelper(url);
  }
}
